<template>
  <div class="row">
    <div class="col-md-6 ml-auto mr-auto">
      <card class="mt-3">
        <div class="card-title">
          Please enter your comments below. Every comment is read by our
          development and support teams and we try to respond within 48 hours.
        </div>
        <form @submit.prevent="onSubmitQuestion">
          <fg-input>
            <label>Course</label>
            <el-select
              class="select-default2"
              size="large"
              name="course"
              :placeholder="courseName"
              :disabled="disableCourse"
              v-model="messageInfo.CourseKey"
            >
              <el-option
                v-for="option in $root.courses"
                class="select-default2"
                :value="option.CourseKey"
                :label="option.CourseName"
                :key="option.CourseName"
              />
            </el-select>
          </fg-input>
          <fg-input>
            <label for="comments">Comments</label>
            <textarea
              class="form-control"
              required
              type="text"
              placeholder=""
              id="comments"
              v-model="messageInfo.Comments"
            />
          </fg-input>
          <div class="text-right">
            <p-button
              type="success"
              native-type="submit"
            >
              Submit
            </p-button>
          </div>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
import mailApi from '@/services/api/mail.js'

export default {
  name: 'Help',
  data: function () {
    return {
      messageInfo: {
        CourseKey: null,
        Comments: null,
        ScouterType: null,
        ScouterKey: null
      },
      disableCourse: true,
      courseName: this.$root.courseName
    }
  },
  mounted () {
    this.ScouterType = this.$root.courseScouterType
    this.ScouterKey = this.$root.scouterKey
    this.CourseKey = this.$root.couorseKey
  },
  methods: {
    onSubmitQuestion: function () {
      mailApi
        .sendUserRequest(this.messageInfo)
        .then(x => {
          this.$notify({
            message: 'Your message has been sent.',
            icon: 'nc-icon nc-satisfied',
            type: 'success',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.messageInfo.Comments = null
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error sending your message.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
